export const Props = () => ({
  //Данные уведомления
  data: { type: Object }
});